import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=463f13d3&scoped=true&"
import script from "./SelectCustomer.vue?vue&type=script&lang=ts&"
export * from "./SelectCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./SelectCustomer.vue?vue&type=style&index=0&id=463f13d3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463f13d3",
  null
  
)

export default component.exports